export enum isEditable {
    true = 'true',
    false = 'false',
}
